import * as React from "react";
import { Col, Label, Modal, Row } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import "../popup/addpopup.scss";
import { toast } from "react-toastify";
import { createEntityGroup } from "@services/entity-mapping.service";
import _ from "lodash";
import { sanitizeInput } from "@_common/dompurify";
interface IAddEntityProps {
	isOpen: boolean;
	handleModal: () => void;
	handleModalCancel: () => void;
	editHeader: boolean;
	headerList: any;
	handleDeleteModal: (item: object) => void;
	handleEditHeader: () => void;
	getHeaderList: () => void;
}

const AddEntity: React.FunctionComponent<IAddEntityProps> = (props) => {
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [levels, setLevels] = React.useState<any>([
		{
			group_name: "",
			group_level: 1,
		},
	]);
	const [submitLoading, setSubmitLoading] = React.useState(false);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	React.useEffect(() => {
		if (getValue(props, `editHeader`, false)) {
			setLevels(getValue(props, `headerList`, []));
		} else {
			setLevels([
				{
					group_name: "",
					group_level: 1,
				},
			]);
			setLevels([...levels]);
		}
	}, [getValue(props, `headerList`, []), getValue(props, `editHeader`, false)]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const handleSubmit = async () => {
		if (getValue(levels, `length`, 0) > 0) {
			let flag = levels.filter((i: any) => !i.group_name || !i.group_level);
			if (getValue(flag, `length`, 0) === 0) {
				let payload;
				if (getValue(props, `editHeader`, false)) {
					payload = levels;
				} else {
					payload = levels.map((item: any) => ({
						group_name: getValue(item, `group_name`, ""),
						group_level: getValue(item, `group_level`, ""),
					}));
				}
				try {
					setSubmitLoading(true);
					let resp = await createEntityGroup({ entity_groups: payload });
					if (resp) {
						props.handleModal();
						props.handleEditHeader();
						props.getHeaderList();
						setSubmitLoading(false);
						toast.success(getValue(resp, `message`, ""));
					} else {
						setSubmitLoading(false);
					}
				} catch (error) {
					setSubmitLoading(false);
				}
			} else {
				toast.error("All Fields are Mandatory");
			}
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const addLevel = (index: number) => {
		// if (getValue(levels, `length`, 0) < 10) {
		levels.push({
			group_name: "",
			group_level: index,
		});
		setLevels([...levels]);
		// } else {
		// 	toast.error("You have reached maximum limit of level creation");
		// }
	};

	const removeLevel = (index: any) => {
		let filtered = levels.filter((_item: any, i: number) => i !== index);
		if (getValue(filtered, `length`, 0) > 0) {
			setLevels(filtered);
		}
	};

	const handleModalCancel = () => {
		props.handleModal();
	};

	const handleChange = (e: any, key: any) => {
		const { name, value } = e.target;
		setLevels(
			levels.map((x: any, index: number) => {
				if (index !== key) return x;
				return {
					...x,
					[name]: sanitizeInput(value),
				};
			})
		);
	};

	const handleDeleteModal = (item: any) => {
		props.handleDeleteModal(item);
	};
	return (
		<Modal
			isOpen={getValue(props, `isOpen`, "")}
			toggle={getValue(props, `isOpen`, "")}
			centered
			className="common-popup-spacing"
		>
			<section className="add-popup-wrapper">
				<h3 className="mt-4" style={{ textAlign: "center" }}>
					Entity Mapping
				</h3>
				<div className="common-popup-spacing__popup">
					{getValue(levels, `length`, 0) > 0 &&
						levels.map((item: object, index: number) => {
							return (
								<Row>
									<Col md={"10"}>
										<Label>
											Group Level : {getValue(item, `group_level`, 1)}
										</Label>
										<InputField
											inputType="TEXT"
											placeholder="Enter Group Level Name"
											name={"group_name"}
											id="group_name"
											value={getValue(item, `group_name`, "")}
											onChange={(e: any) => handleChange(e, index)}
										/>
									</Col>
									{getValue(levels, `length`, 0) - 1 === index && (
										<Col
											className="list-managemnet-wrapper__form-add-icon"
											md={"2"}
											onClick={() =>
												getValue(item, `id`, '')
													? handleDeleteModal(item)
													: removeLevel(index)
											}
										>
											<img
												src="/images/close-red.svg"
												className="img-fluid cursor-pointer"
												style={{
													height: "30px",
													width: "30px",
													marginTop: "25px",
												}}
											/>
										</Col>
									)}
								</Row>
							);
						})}
					{getValue(levels, `length`, 0) < 10 && (
						<div
							onClick={() => addLevel(getValue(levels, `length`, 0) + 1)}
							style={{ cursor: "pointer", color: "#266ef1" }}
						>
							Add More
						</div>
					)}
					<div className="add-popup-wrapper__cta-wrapper">
						<button
							onClick={handleModalCancel}
							className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
						>
							Cancel
						</button>
						<button
							className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
							onClick={handleSubmit}
							disabled={submitLoading}
						>
							{submitLoading
								? "Please wait..."
								: //  getValue(props, `editHeader`, false)
								  // 	? "Update"
								  // 	: "Add"
								  "Submit"}
						</button>
					</div>
				</div>
			</section>
		</Modal>
	);
};

export default AddEntity;
